import i18next, { type TFunction } from 'i18next';

const warned = new Set<string>();

/** One warning per missing key, and only in a development build. */
function warnUnknown(key: string): void {
  if (!import.meta.env.DEV || warned.has(key)) return;
  warned.add(key);
  console.warn(`Unknown catalog key ${key}`);
}

/**
 * The catalog string at `key`, or "—" (`statements.unavailable`) when it is missing.
 * Never the raw key or the raw wire value.
 */
export function catalogLabel(t: TFunction, key: string): string {
  if (i18next.exists(key)) return t(key);
  warnUnknown(key);
  return t('statements.unavailable');
}

/** `${prefix}.${value}` when the catalog has it; otherwise "—" (never the raw value). */
export function enumLabel(t: TFunction, prefix: string, value: string): string {
  return catalogLabel(t, `${prefix}.${value}`);
}
